module.exports = __webpack_public_path__ + "img/Testimonials-bg.463f6b53.jpg";